import { useContext } from "react";
import { TasksContext } from "./TasksProvider";

export const useTasks = () => useContext(TasksContext);
